import { queryFetch } from '../api';
import { useMutation } from '@tanstack/react-query';
import { usePanel } from '@hooks/usePanel';
import { SignInReq, SignInResp } from './types';

export const useSignIn = ({ callback }: { callback: (data: SignInResp) => void }) => {
  const { panel } = usePanel();

  const { mutate, isPending } = useMutation({
    mutationKey: ['signIn'],
    mutationFn: ({ ...data }: SignInReq): Promise<SignInResp> =>
      queryFetch({
        url: [panel ? 'admins' : 'resources/users', 'sign_in'].join('/'),
        data,
        opt: { method: 'POST' },
        auth: false,
        panel,
      }),
    onError: (err) => {
      console.error(err);
    },
    onSettled: (data) => {
      if (!data) return;
      callback(data);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
